// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  royaltyId: __t.u64().primaryKey().name("royalty_id"),
  assetId: __t.u64().name("asset_id"),
  originalCreator: __t.identity().name("original_creator"),
  fromSaleTx: __t.u64().name("from_sale_tx"),
  amountSov: __t.i64().name("amount_sov"),
  at: __t.timestamp(),
});
